import type { VideoVoteResult } from 'data/video-votings';
import { setVideoVoteAsync } from 'data/video-votings';
import { EstimationSlider } from 'open-modules/zdf/videovoting/estimationSlider';
import { useVideoVotingSessionData } from 'open-modules/zdf/videovoting/videoVotingSession';
import React from 'react';
import { trackEvent } from 'util/analytics';
import { useDatastore } from 'util/datastore';
import { fireAndForget } from 'util/hooks';

import type { VideoVotingQuestionEstimation } from './videovoting-types';

type VideoVotingQuestionEstimationProps = {
    question: VideoVotingQuestionEstimation;
    ownVote?: VideoVoteResult | undefined;
};
export function VideoVotingQuestionEstimationDialog({ question, ownVote }: VideoVotingQuestionEstimationProps) {
    const datastore = useDatastore();
    const session = useVideoVotingSessionData();

    // One call whether or not an estimate is already stored: the server decides
    // whether this replaces a row or adds one.
    const voteForSliderValue = (value: number) => {
        const votingKey = session.votingKey;
        if (!votingKey) return;

        fireAndForget(
            setVideoVoteAsync(datastore, {
                votingKey,
                questionKey: question.key,
                value,
                anonymous: session?.anonymous ?? false,
            }),
        );

        trackEvent(datastore, 'videovoting-vote', {
            questionKey: question.key,
            questionText: question.text,
            value: value.toString(),
            anonymous: session?.anonymous?.toString(),
            videoVotingSessionId: session.id,
        });
    };

    return (
        // TODO: stepSize and possibly snapOnMove should be configurable via the
        // video voting editor but they currently aren't
        <EstimationSlider
            isUnitBeforeValue={question.isUnitBeforeValue}
            max={question.maxValue}
            min={question.minValue}
            onChangeValue={voteForSliderValue}
            snapOnMove={false}
            unit={question.unit}
            value={ownVote?.value ?? question.minValue}
        />
    );
}
